import { render, staticRenderFns } from "./PermissionsSelect.vue?vue&type=template&id=e9f1c2f6&scoped=true&"
import script from "./PermissionsSelect.vue?vue&type=script&lang=js&"
export * from "./PermissionsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f1c2f6",
  null
  
)

export default component.exports